import React from 'react';
import { FaCheck } from 'react-icons/fa';

import { useLocalTranslation } from '../../../common/hooks/useLocalTranslation';

import { AnswerValues } from './PublicSurveyContainer';

interface PublicYesNoQuestionProps {
  value?: boolean;
  onChange: (value: AnswerValues) => void;
  currentLanguage: string;
}

export const PublicYesNoQuestion: React.FC<PublicYesNoQuestionProps> = ({
  value,
  onChange,
  currentLanguage,
}) => {
  const { t, tk } = useLocalTranslation('administrationLng', currentLanguage);
  return (
    <div className="d-flex flex-column gap-3">
      <button
        type="button"
        onClick={() => onChange({ booleanValue: true })}
        className={`public-survey-radio-option ${value === true ? 'selected' : ''}`}
      >
        <div
          className={`public-survey-radio-indicator ${value === true ? 'selected' : ''}`}
        >
          {value === true && <FaCheck color="white" size={12} />}
        </div>
        <span className="public-survey-radio-label">
          {t(tk.publicSurvey.yes)}
        </span>
      </button>

      <button
        type="button"
        onClick={() => onChange({ booleanValue: false })}
        className={`public-survey-radio-option ${value === false ? 'selected' : ''}`}
      >
        <div
          className={`public-survey-radio-indicator ${value === false ? 'selected' : ''}`}
        >
          {value === false && <FaCheck color="white" size={12} />}
        </div>
        <span className="public-survey-radio-label">
          {t(tk.publicSurvey.no)}
        </span>
      </button>
    </div>
  );
};
